import { profile } from "../../data/content";
import { Reveal, Overline } from "./Reveal";

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative max-w-6xl mx-auto px-6 md:px-12 py-24 md:py-32"
  >
    <div className="grid md:grid-cols-12 gap-10 md:gap-16">
      <div className="md:col-span-4">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="font-mono-tech text-xs tracking-[0.25em] text-tertiary-c">
              01
            </span>
            <span className="h-px w-8 bg-[var(--border-strong)]" />
            <Overline>About</Overline>
          </div>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-primary-c leading-tight">
            Engineering as a business decision.
          </h2>
        </Reveal>
      </div>

      <div className="md:col-span-8 space-y-6">
        {profile.about.map((p, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <p
              data-testid={`about-paragraph-${i}`}
              className="text-lg md:text-xl leading-relaxed text-secondary-c [&_strong]:text-primary-c"
            >
              {p}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
